/* eslint-disable react/no-did-mount-set-state */
/* eslint-disable react/no-did-update-set-state */
import React, { Component } from 'react';
import SovosRaisedButton from "s1-ui/sovos-raised-button/SovosRaisedButton";
import SovosButtonsGroup from "s1-ui/sovos-buttons-group/SovosButtonsGroup";
import './OrgCreationEditor.scss';
import { Link } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import SovosSnackbar from 's1-ui/sovos-snackbar/SovosSnackbar';
import CircularProgress from '@material-ui/core/CircularProgress';

export default class OrgCreationEditor extends Component {

  constructor(props) {
    const { selectedOrg } = props;
    super(props);
    this.state = {
      name: selectedOrg.name,
      orgCode: '',
      user: '',
      password: '',
      hmac: '',
    };
  }

  componentDidMount() {
    this.props.organizationsActions.fetchOrganization();
    const { code, gtdUser, isGtdPasswordSet, isGtdHmacSet } = this.props.organization;
    this.setState(() => ({
      name: this.props.selectedOrg.name,
      orgCode: code,
      user: gtdUser,
      hmac: isGtdHmacSet ? '******' : '',
      password: isGtdPasswordSet ? '******' : '',
    }));
  }

  componentDidUpdate(prevProps) {

    if (this.props.selectedOrg.id !== prevProps.selectedOrg.id) {
      this.props.organizationsActions.fetchOrganization();
    }

    if (this.props.organization.code !== prevProps.organization.code) {
      const { code, gtdUser, isGtdPasswordSet, isGtdHmacSet } = this.props.organization;
      this.setState(() => ({
        name: this.props.selectedOrg.name,
        orgCode: code,
        user: gtdUser,
        hmac: isGtdHmacSet ? '******' : '',
        password: isGtdPasswordSet ? '******' : '',
      }));
    }
  }

  handleSaveOrganization = () => {
    const { orgCode, user, password, hmac } = this.state;
    this.props.organizationsActions.saveOrganization(orgCode, user, password, hmac);
    if ( this.props.savedOrganizationFlag ) {
      this.setState( () => ({
        openSuccessfulSnackbar: true
      }));
    }
    if ( this.props.savedOrganizationFailureFlag  ) {
      this.setState( () => ({
        openFailureSnackbar: true
      }));
    }
  }


  handleInputChange = name => event => {
    this.setState({ [name]: event.target.value });
  };


  render() {
    return (
      <div>
        <div className="org-creation-editor__container ">
          <h1>
            <Link to="/settings" >
              Settings
            </Link>
            /
            <strong>
              GTD Credentials
            </strong>
          </h1>
          <SovosButtonsGroup
            align="right"
            style={ { marginTop: 16 } }
          >
            <SovosRaisedButton onClick={ this.handleSaveOrganization } disabled={ this.props.savingOrganization }>
              SAVE
            </SovosRaisedButton>
          </SovosButtonsGroup>
        </div>
        <hr />
        <div className="org-creation-editor__form">
          <TextField
            id="org-name"
            label="Org Name"
            disabled
            value={ this.state.name }
            margin="normal"
          />
          <TextField
            id="org-code"
            label="GTD Org Code"
            disabled={ this.props.savingOrganization }
            value={ this.state.orgCode }
            onChange={ this.handleInputChange('orgCode') }
            margin="normal"
          />
          <TextField
            id="user"
            label="GTD User"
            disabled={ this.props.savingOrganization }
            value={ this.state.user }
            onChange={ this.handleInputChange('user') }
            margin="normal"
          />
          <TextField
            id="password"
            label="GTD Password"
            type="password"
            disabled={ this.props.savingOrganization }
            value={ this.state.password }
            onChange={ this.handleInputChange('password') }
            margin="normal"
          />
          <TextField
            id="hmac"
            label="GTD HMAC"
            type="password"
            disabled={ this.props.savingOrganization }
            placeholder={ this.state.hmac ? '*******' : '' }
            value={ this.state.hmac }
            onChange={ this.handleInputChange('hmac') }
            margin="normal"
          />
        </div>

        <SovosSnackbar
          open={ this.props.savedOrganizationFlag }
          message="GTD credentials successfully saved."
          variant="confirmation"
          onClose={ this.props.organizationsActions.clearOrganizationFlags }
        />

        <SovosSnackbar
          open={ this.props.savedOrganizationFailureFlag }
          message="There was an error when trying to save the credentials."
          variant="error"
          onClose={ this.props.organizationsActions.clearOrganizationFlags }
        />

        {
          this.props.savingOrganization &&
          <CircularProgress style={ {color: "#2BC0F2"} } className="spinner" size="5rem"/>
        }

      </div>
    );
  }

}

OrgCreationEditor.propTypes = {
  savedOrganizationFlag: PropTypes.bool,
  savedOrganizationFailureFlag: PropTypes.bool,
  savingOrganization: PropTypes.bool,
  selectedOrg: PropTypes.object,
  organization: PropTypes.object,
  organizationsActions: PropTypes.shape({
    fetchOrganization: PropTypes.func,
    saveOrganization: PropTypes.func,
    clearOrganizationFlags: PropTypes.func
  })
};



// WEBPACK FOOTER //
// ./src/components/orgCreation/orgCreationEditor/OrgCreationEditor.js